import React from 'react';

function Map({ src, title }) {
    return (
        <div id="map">
            <iframe
                key={src}
                title={title || 'map'}
                src={src}
                frameBorder="0"
                style={{
                    border: '0',
                    width: '100%',
                }}
                allowFullScreen=""
                aria-hidden="false"
                loading="lazy"
            />
        </div>
    );
}

export default Map;
